

/** Header above cells */
export const GRID_HEADER_HEIGHT = 22;
export const MONTH_GRID_OFFSET_X = 8;
export const MONTH_GRID_OFFSET_Y = 16;

export const BUTTON_HEIGHT = 28;
export const BUTTON_HPADDING = 8;

export const ICON_FONT = "AnnecaSymbols";

/** Top level header height */
export const HEADER_HEIGHT = BUTTON_HEIGHT + 8;

export const SPLITTER_WIDTH = 4;

export const GUTTER_PADDING = 8;
export const GUTTER_FONT_SIZE = 12;
export const GRID_HEADER_FONT_SIZE = 12;

// These should be divisible by 4 (to draw good dividers)
export const MIN_HOUR_HEIGHT = 24;
export const MAX_HOUR_HEIGHT = 128;